import React from 'react';
import { Button, Icon, Table, Header, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import SearchTableData from '../../util/SearchTableData';
import { Link } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema arhiviranih smjerova (studijskih programa).</p>;

export default class ArchivedStudyPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            faculties: [],

            loading: true,

            results: []
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.backToStudyPrograms = this.backToStudyPrograms.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post(`study-programs/basic/${localStorage.getItem('orgUnitId')}`, { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el, studyProgramBasicName: el.studyProgramBasic.name
                    })),
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch StudyPrograms');
            });
    }

    backToStudyPrograms() {
        this.props.backToStudyPrograms(0, localStorage.getItem('orgUnitId'), this.props.orgUnitName);
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results.filter(el => el.studyProgramBasic.archived === true);
        }
        return this.state.data.filter(el => el.studyProgramBasic.archived === true);
    }

    getResults(results) {
        this.setState({ results });
    }

    render() {
        return (
            <div>

                {this.getDataToRender().length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={11} >
                                    <div style={{ paddingLeft: '30px' }}>
                                        <SearchTableData data={this.state.data.filter(el => el.studyProgramBasic.archived === true)} getResults={this.getResults} filterItem={['studyProgramBasicName', 'description', 'enrollmentTerms', 'name', 'department']} />
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">
                                    R. br.
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>
                                    <Header as="h4">
                                        <Header.Content>
                                            Naziv studijskog programa (B/H/S)
                                        </Header.Content>
                                        <Header.Subheader>Naziv studijskog programa (EN)</Header.Subheader>
                                    </Header>
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={4}>*/}
                                {/*    Naziv smjera (studijskog programa)*/}
                                {/*</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={3}>
                                    Broj odluke
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    Napomena
                                </Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={4}>
                                    {el.studyProgramBasicName} {el.studyProgramBasic.translations && el.studyProgramBasic.translations.map(e => (<div style={{ color: '#a6a4a1' }}>{e.name}<br /></div>))}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.studyProgramBasic.documentNumber}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {el.studyProgramBasic.comment}
                                </Table.Cell>

                                <Table.Cell textAlign="center" verticalAlign="middle" width={1}>
                                    <Link to={{ pathname: '/osnovni-studijski-programi/implementacije', state: { id: el.studyProgramBasic.id, name: el.studyProgramBasic.name } }}>
                                        <Popup
                                            content="Implementacije"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="blue"
                                                    icon="folder open"
                                                    onClick={() => {
                                                        localStorage.setItem('studyCycles', JSON.stringify(el.studyProgramBasic.studyCycles.map(e => ({
                                                            key: e.id, value: e.id, text: e.displayName
                                                        }))));
                                                        localStorage.setItem('archived', true);
                                                    }}
                                                    // onClick={() => { localStorage.setItem('studyProgramBasic', el.studyProgramBasic.id); localStorage.setItem('studyProgramBasicName', el.studyProgramBasic.name); }}
                                                />}
                                        />
                                    </Link>
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/ArchivedStudyPrograms.js